import React from "react";
import "../styles/LegalPages.css";
import Header from "../components/Header"; // ✅ Certifique-se de que o caminho está correto

const TermsOfService = () => {
  return (
     <>
      <Header /> {/* ✅ Aqui o Header será exibido no topo da página */}

    <div className="legal-container">
      <h1>Termos de Uso</h1>
      <p>Última atualização: 13 de fevereiro de 2025</p>

      <section>
        <h2>1. Aceite dos Termos</h2>
        <p>
          Este <strong>Contrato de Licença de Usuário Final ("EULA")</strong> é um acordo entre o usuário do sistema <strong>RondaGO</strong> (“LICENCIADO”) e a empresa <strong>ACL Administração de Aplicativos LTDA</strong>, responsável pelo desenvolvimento e operação do sistema RondaGO (“LICENCIANTE”).
        </p>
        <p>
          O <strong>RondaGO</strong> é um software de gestão operacional para condomínios, disponibilizado via aplicativo e plataforma web.
        </p>
        <p>
          Ao acessar ou utilizar o <strong>RondaGO</strong>, mesmo que parcialmente ou a título de teste, o LICENCIADO concorda integralmente com os termos deste <strong>EULA</strong>. Caso discorde, o uso do sistema deve ser interrompido imediatamente.
        </p>

      </section>

      <section>
        <h2>2. Propriedade Intelectual</h2>
        <p>
          O <strong>RondaGO</strong> é um sistema desenvolvido e operado pela LICENCIANTE, incluindo marca, logotipos, código-fonte e documentação.
        </p>

        <ul>
          <li>O LICENCIADO não adquire nenhum direito sobre o sistema além do uso concedido.</li>
          <li>É proibido copiar, modificar, distribuir, vender ou revender qualquer parte do RondaGO.</li>
          <li>É vedado o uso para fins ilegais ou que comprometam a integridade da plataforma.</li>
        </ul>
      </section>

      <section>
        <h2>3. Uso do Software</h2>
        <p>
          O LICENCIADO se compromete a utilizar o <strong>RondaGO</strong> conforme suas finalidades, como:
        </p>
        <ul>
          <li>Gerenciamento de rondas, inspeções e tarefas operacionais via QR Code.</li>
          <li>Controle de ativos, documentos e ocorrências em condomínios.</li>
          <li>Cadastro e gestão de colaboradores e equipes.</li>
        </ul>
        <p>O uso abusivo ou ilícito do sistema pode resultar na suspensão do acesso.</p>
      </section>

      <section>
        <h2>4. Pagamentos e Assinaturas</h2>
        <p>
          O <strong>RondaGO</strong> opera com planos pagos conforme descritos na página de assinaturas. O LICENCIADO concorda que:
        </p>
        <ul>
          <li>O pagamento deve ser realizado via cartão de crédito ou outros meios disponíveis.</li>
          <li>A renovação da assinatura ocorre automaticamente, salvo cancelamento prévio.</li>
          <li>O cancelamento pode ser feito a qualquer momento, mas não há reembolso de valores já pagos.</li>
          <li>O não pagamento pode resultar na suspensão do acesso.</li>
        </ul>
      </section>

      <section>
        <h2>5. Privacidade e Proteção de Dados</h2>
        <p>
          A LICENCIANTE se compromete a proteger os dados do LICENCIADO em conformidade com a <strong>Lei Geral de Proteção de Dados (LGPD – Lei 13.709/2018)</strong>.
        </p>
        <p>Os dados coletados incluem:</p>
        <ul>
          <li><strong>Dados pessoais:</strong> Nome, e-mail, telefone, CPF, endereço.</li>
          <li><strong>Dados de uso:</strong> IP, dispositivo, páginas acessadas.</li>
          <li><strong>Dados operacionais:</strong> Informações inseridas voluntariamente pelo usuário.</li>
        </ul>
        <p>
          Esses dados são armazenados de forma segura e podem ser compartilhados apenas para cumprimento de obrigações legais ou com parceiros essenciais para o funcionamento do sistema.
        </p>
      </section>

      <section>
        <h2>6. Limitações de Responsabilidade</h2>
        <p>
          O <strong>RondaGO</strong> é fornecido "no estado em que se encontra" e pode ser atualizado periodicamente. A LICENCIANTE não se responsabiliza por:
        </p>
        <ul>
          <li>Erros causados pelo próprio usuário ou falhas de terceiros.</li>
          <li>Interrupções temporárias por manutenção ou problemas na internet.</li>
          <li>Danos indiretos, lucros cessantes ou prejuízos decorrentes do uso do sistema.</li>
          <li>Invasões ou ataques hackers causados por terceiros.</li>
        </ul>
      </section>

      <section>
        <h2>7. Cancelamento e Rescisão</h2>
        <p>
          O LICENCIADO pode cancelar sua assinatura a qualquer momento pelo próprio sistema ou via e-mail. A LICENCIANTE pode suspender ou encerrar o acesso ao sistema caso:
        </p>
        <ul>
          <li>Haja descumprimento dos termos.</li>
          <li>O sistema seja utilizado para fins ilícitos.</li>
          <li>O pagamento da assinatura não seja regularizado em 30 dias.</li>
        </ul>
        <p>Os dados do usuário podem ser excluídos após 30 dias do cancelamento.</p>
      </section>

      <section>
        <h2>8. Atualizações e Modificações</h2>
        <p>
          A LICENCIANTE pode modificar ou encerrar funcionalidades sem aviso prévio, visando melhorias na plataforma. 
        </p>
        <p>O uso contínuo do sistema após mudanças implica aceitação dos novos termos.</p>
      </section>

      <section>
        <h2>9. Foro e Legislação Aplicável</h2>
        <p>
          Este contrato será regido pelas leis brasileiras e eventuais disputas serão resolvidas no foro da Comarca de [sua cidade], com exclusão de qualquer outro.
        </p>
      </section>

      <section>
        <h2>10. Contato</h2>
        <p>
          Para dúvidas sobre este <strong>Termo de Uso</strong>, entre em contato:
        </p>
        <p>
          📩 <a href="mailto:contato@rondago.com.br">contato@rondago.com.br</a><br />
          🏢 ACL Administração de Aplicativos LTDA<br />
        </p>
      </section>
    </div>
        </>

  );
};

export default TermsOfService;
